// call-history.js — historique d'appels strictement local.
// v4.9.0 : le JSON est chiffré dans localStorage avec la clé du coffre quand
// celui-ci est ouvert. Les tests/anciens navigateurs sans coffre gardent le
// format legacy afin de préserver la compatibilité.
import { isVaultUnlocked, sealLocalString, openLocalString } from './local-vault.js';

export const CALL_HISTORY_KEY = 'messagerie:audio-call-history:v1';
export const MAX_CALL_HISTORY = 40;
const OUTCOMES = new Set(['completed', 'missed', 'no-answer', 'declined', 'busy', 'cancelled', 'failed']);
const DIRECTIONS = new Set(['incoming', 'outgoing']);
const MEDIA = new Set(['audio', 'video']);

function safeEntry(raw) {
  if (!raw || typeof raw !== 'object') return null;
  const peer = typeof raw.peer === 'string' ? raw.peer.trim().slice(0, 80) : '';
  const direction = DIRECTIONS.has(raw.direction) ? raw.direction : '';
  const outcome = OUTCOMES.has(raw.outcome) ? raw.outcome : '';
  const startedAt = Number(raw.startedAt || 0), endedAt = Number(raw.endedAt || 0);
  const durationSeconds = Math.max(0, Math.min(24 * 60 * 60, Math.floor(Number(raw.durationSeconds || 0))));
  const media = MEDIA.has(raw.media) ? raw.media : 'audio';
  if (!peer || !direction || !outcome || !Number.isFinite(startedAt) || startedAt <= 0) return null;
  return { peer, direction, media, outcome, startedAt, endedAt: Number.isFinite(endedAt) && endedAt >= startedAt ? endedAt : startedAt, durationSeconds };
}
function readText(storage) {
  const raw = storage?.getItem?.(CALL_HISTORY_KEY) || '[]';
  if (!isVaultUnlocked()) return raw;
  try { return openLocalString('call-history', raw) || '[]'; } catch (_) { return '[]'; }
}
function writeText(storage, text) {
  if (!storage?.setItem) return false;
  storage.setItem(CALL_HISTORY_KEY, isVaultUnlocked() ? sealLocalString('call-history', text) : text);
  return true;
}
export function readCallHistory(storage = globalThis.localStorage) {
  try { const parsed = JSON.parse(readText(storage)); return Array.isArray(parsed) ? parsed.map(safeEntry).filter(Boolean).slice(0, MAX_CALL_HISTORY) : []; }
  catch (_) { return []; }
}
export function appendCallHistory(entry, storage = globalThis.localStorage) {
  const clean = safeEntry(entry); if (!clean || !storage?.setItem) return false;
  try { return writeText(storage, JSON.stringify([clean, ...readCallHistory(storage)].slice(0, MAX_CALL_HISTORY))); }
  catch (_) { return false; }
}
export function clearCallHistory(storage = globalThis.localStorage) { try { storage?.removeItem?.(CALL_HISTORY_KEY); return true; } catch (_) { return false; } }
export function migrateCallHistoryEncryption(storage = globalThis.localStorage) {
  if (!isVaultUnlocked() || !storage?.getItem?.(CALL_HISTORY_KEY)) return false;
  try { return writeText(storage, JSON.stringify(readCallHistory(storage))); } catch (_) { return false; }
}
